import { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import { LOGO_URL } from "@/config/assets";

const LINKS = [
  { label: "About Us", href: "#about" },
  { label: "Venues & Amenities", href: "#venues" },
  { label: "Gallery", href: "#gallery" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <nav
      data-testid="main-navbar"
      className={`fixed top-0 inset-x-0 z-50 border-b border-[#D4AF37]/20 transition-colors duration-500 ${
        scrolled ? "backdrop-blur-xl bg-[#043927]/90" : "bg-gradient-to-b from-black/60 to-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 flex items-center justify-between h-20">
        <a href="#hero" data-testid="nav-logo-link" className="flex items-center gap-3">
          <img src={LOGO_URL} alt="Leelarav Greens logo" className="h-12 w-12 rounded-sm object-cover border border-[#D4AF37]/40" />
          <div className="leading-tight">
            <span className="font-serif-luxe text-xl md:text-2xl font-semibold tracking-wide text-[#F3E5AB] block">Leelarav Greens</span>
            <span className="text-[10px] uppercase tracking-[0.35em] text-[#D4AF37]">Luxury Venue</span>
          </div>
        </a>

        <div className="hidden md:flex items-center gap-10">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              className="text-sm tracking-wide text-[#FAF9F6]/90 hover:text-[#D4AF37] transition-colors duration-300"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#contact"
            data-testid="nav-book-now-btn"
            className="gold-btn px-6 py-2.5 rounded-sm text-sm font-semibold tracking-wider uppercase"
          >
            Book Now
          </a>
        </div>

        <button
          data-testid="nav-mobile-toggle"
          className="md:hidden text-[#D4AF37]"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {open && (
        <div data-testid="nav-mobile-menu" className="md:hidden backdrop-blur-xl bg-[#043927]/95 border-t border-[#D4AF37]/20 px-6 py-6 space-y-4">
          {LINKS.map((l) => (
            <a key={l.href} href={l.href} onClick={() => setOpen(false)} className="block text-[#FAF9F6] tracking-wide hover:text-[#D4AF37] transition-colors duration-300">
              {l.label}
            </a>
          ))}
          <a href="#contact" onClick={() => setOpen(false)} data-testid="nav-mobile-book-now-btn" className="gold-btn inline-block px-6 py-2.5 rounded-sm text-sm font-semibold tracking-wider uppercase">
            Book Now
          </a>
        </div>
      )}
    </nav>
  );
};
